var _style, _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNano(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4A90E2;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 42.1,
    cy: 185.9,
    r: 18.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.3,95.9c-9.8,0-18.1,7.9-18.1,18.1c0,14.4-2.3,18.1-18.1,18.1h-1.5c-9.1,0.8-16.3,8.3-16.3,17.8v0.4 c0,14-2.7,17.4-18.1,17.4c-0.8,0-1.5,0-1.9,0.4c-9.1,1.1-16.3,8.7-16.3,17.8c0,9.8,7.9,18.1,18.1,18.1c9.4,0,17.4-7.6,17.8-16.6 v-1.5c0-12.9,4.2-17.8,17.8-18.1h0.4c9.4,0,17.4-7.6,17.8-17v-1.1c0-13.2,4.2-18.1,18.1-18.1c9.8,0,18.1-7.9,18.1-18.1 C276.1,103.9,268.1,95.9,258.3,95.9z M151.7,132.2h-1.5c-15.9,0-18.1-3.8-18.1-18.1c0-9.8-7.9-18.1-18.1-18.1 c-9.8,0-18.1,7.9-18.1,18.1c0,14.4-2.3,17.8-18.1,17.8h-1.5c-9.1,0.8-16.3,8.3-16.3,17.8c0,9.8,7.9,18.1,18.1,18.1 c9.4,0,17.4-7.6,17.8-16.6V150c0-13.2,4.2-18.1,18.1-18.1s18.1,4.9,18.1,17.8c0,9.8,7.9,18.1,18.1,18.1s18.1-7.9,18.1-18.1 C168,140.6,160.8,133,151.7,132.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNano);
export default __webpack_public_path__ + "static/media/NANO.8cf58d3dd422731bbe1aad3fe4601a14.svg";
export { ForwardRef as ReactComponent };